import {Invoice,} from '../types';
import {PlatformPropertyCard} from "@flexinet/ui-components";
import {CreatedByProfileFormatter} from "../../../components/CreatedByProfileFormatter.tsx";
import {Stack} from "@mantine/core";
import {NavLink} from 'react-router-dom';

export const Profile = ({record}: { record: Invoice }) => {

    const informationProperties = [
        {
            label: 'Invoice ID',
            value: record.id as string,
            span: 12,
        }, {
            label: 'Customer',
            value: record.customer ? 
                <NavLink to={`/customers/${record.customerId}`}>{record.customer.name}</NavLink> :
                <NavLink to={`/customers/${record.customerId}`}>{record.customerId}</NavLink>,
            span: 12,
        }];

    const metadataProperties = [
        {
            label: 'Created By',
            value: <CreatedByProfileFormatter record={record as any}/>,
            rbac: 'UpdateInvoice',
            span: 12,
        },
        {
            label: 'Created',
            value: record.created as string,
            formatAs: 'Timestamp',
            span: 12,
        },
        {
            label: 'Last Updated',
            value: record.updated as string,
            formatAs: 'Timestamp',
            span: 12,
        }];


    return (
        <Stack gap={'xl'}>
            <PlatformPropertyCard properties={informationProperties}/>
            <PlatformPropertyCard properties={metadataProperties}/>
        </Stack>
    );


};